(function ($, Drupal) {
  'use strict'

  Drupal.behaviors.SocialLinks = {
    attach: function (context) {
      const SOCIAL_BTNS_ID = '.js-social-link';

      function socialLinks () {
        if (document.querySelectorAll(SOCIAL_BTNS_ID).length === 0) {
          return;
        }
        document.querySelectorAll(SOCIAL_BTNS_ID).forEach((socialBtn) => {
          socialBtn.addEventListener('click', (e) => {
            const { title: eventLabel } = e.currentTarget;
            pushSocialEvent({
              eventLabel,
            });
          });
        });
      };
    socialLinks()
    }
  }

}) (jQuery, Drupal)